import React from 'react';
import PropTypes from 'prop-types';
import './Header.css';

export default function Header({ companySite }) {

    return(
        <div id={'header'}>
            <h1>
                <a id={'logo'} href={companySite}>Executive Storage Suites</a>
            </h1>
        </div>
    );
}

Header.propTypes = {
    companySite: PropTypes.string.isRequired,
};
